import React from 'react';
import classNames from 'classnames';

interface ListProps {
  /** ListItems to display */
  children: React.ReactElement[]; // TODO: how to type correctly? ReactNode has no map.
  /** HeadLine for the List. */
  header?: React.ReactNode;
  /** CSS class name. */
  className?: string;
  /** Icon displayed on every ListItem. */
  icon?: string;
}

/** Displays a list of ListItems given as children. */
const List = ({ children, className, header, icon }: ListProps) => {
  const items = children.map((listItem, index) => {
    if (!listItem.props.icon && icon) {
      return React.cloneElement(listItem, {
        icon,
        key: `list-item_${index}`, // eslint-disable-line react/no-array-index-key
      });
    }
    return listItem;
  });

  return (
    <div className={classNames(className, 'ce')}>
      {header}
      <ul>{items}</ul>
    </div>
  );
};

List.defaultProps = {
  className: null,
  header: null,
  icon: null,
};

export default List;
